import {lazy} from "react"

export const Routes = [
    {
        path: "/login",
        component: lazy(() => import("../views/auth/Login")),
        layout: "BlankLayout",
        meta: {
            authRoute: true
        }
    },
    {
        path: "/dashboard",
        component: lazy(() => import("../views/dashboard")),
        meta: {
            general: true
        }
    },
    {
        path: "/privacy",
        component: lazy(() => import("../views/privacy")),
        layout: "BlankLayout",
        meta: {
            publicRoute: true
        }
    },
    {
        path: "/admin/list",
        component: lazy(() => import("../views/admin-list")),
        meta: {
            action: "call",
            resource: "view.main.admins.tab.list"
        }
    },
    {
        path: "/notifications",
        component: lazy(() => import("../../influencers/views/notifications")),
        meta: {
            action: "call",
            resource: "view.main.notifications.tab.list"
        }
    },
    {
        path: "/horizon",
        component: lazy(() => import("../views/horizon")),
        meta: {
            action: "call",
            resource: "view.main.queue.horizon.tab.list",
            publicRoute: true
        }
    }
    // {
    //     path: "/scraping-jobs/list",
    //     component: lazy(() => import("../views/scraping-jobs-list")),
    //     meta: {
    //         action: "call",
    //         resource: "ROLES_VIEW_LIST"
    //     }
    // },
]
